import React, { useEffect, useState, useRef } from 'react'
import ImageNotAvailable from '../../assets/image-not-available.png'
import PlayIcon from '../../assets/Content-Icons/Svgs/play-circle.svg'
import Icon8K from '../../assets/videoQuality/8k-icon.png'
import Icon4K from '../../assets/videoQuality/4k-icon.png'
import Icon2K from '../../assets/videoQuality/2k-icon.png'
import Icon1080P from '../../assets/videoQuality/1080p-icon.png'
import Icon720P from '../../assets/videoQuality/720p-icon.png'
import Icon480P from '../../assets/videoQuality/480p-icon.png'
import Icon360P from '../../assets/videoQuality/360p-icon.png'
import CustomImage from 'src/components/customImage/customImage'
import InformationTagIcon from '../../assets/Content-Icons/Svgs/information-tag-icon.svg'
import TanscodingFailureIcon from '../../assets/tanscoding-failure-icon.svg'
import { isEmpty } from 'lodash'
import { CProgress, CProgressBar } from '@coreui/react'
import { Dropdown } from 'react-bootstrap'
import OptionsBtn from '../../assets/elipsis-icon.svg'

const CustomTileCard = ({
  cardStyle = {},
  cardImage = '',
  textData = [],
  categories = [],
  transscodeData = [],
  transcodeEnable = false,
  playIconForVideo = false,
  actionButtonOptions = [],
  transcodingError = '',
  cardImgWidth = '10%',
  categoriesWidth = '25%',
  actionButtonWidth = '5%',
}) => {
  const categoryStyles = {
    background: '#d6d2d2',
    padding: '.25ch 1ch',
    borderRadius: '10px',
    marginRight: '.5vw',
    display: 'inline-block',
  }

  const elementRef = useRef([])
  const containerElementRef = useRef(null)
  const [contentCategories, setContentCategories] = useState(categories)

  const [extraCategories, setExtraCategories] = useState([])
  const [visibleCategories, setVisibleCategories] = useState([])

  useEffect(() => {
    let tempExtraCategory = []
    let tempExtraCategoryTexts = []
    let categoriesContainerWidth = containerElementRef.current?.clientWidth // categories container width
    let categoriesWidths = elementRef.current.map((item) => item?.clientWidth) // categories Width(s) array
    let categoriesTexts = elementRef.current.map((item) => item.innerHTML) // categories Text(s) array
    let getSumOfCategoriesWidth = () => categoriesWidths.reduce((a, b) => a + b, 0) // getter for sum of categories width(s)
    while (getSumOfCategoriesWidth() > categoriesContainerWidth) {
      tempExtraCategory.push(categoriesWidths.pop())
      tempExtraCategoryTexts.push(categoriesTexts.pop())
    }
    setVisibleCategories(categoriesTexts)
    setExtraCategories(tempExtraCategory)
  }, [])

  useEffect(() => {
    setContentCategories(visibleCategories)
  }, [visibleCategories])

  const ResolutionsIcon = {
    360: Icon360P,
    480: Icon480P,
    720: Icon720P,
    1080: Icon1080P,
    2048: Icon2K,
    3840: Icon4K,
    7680: Icon8K,
  }
  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '1181/78',
        boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        display: 'flex',
        background: '#ececec',
        padding: '.4vw 0',
        ...cardStyle,
      }}
      className={`rounded-1`}
      tabIndex={0}
    >
      <div
        className="relative rounded-lg mx-2 d-flex justify-content-center align-items-center p-1"
        style={{ height: '100%', width: cardImgWidth }}
      >
        <CustomImage
          className="card-img-top w-auto h-auto"
          imageUrl={cardImage}
          loaderStyle={{ height: '100%' }}
          errorPlaceholder={ImageNotAvailable}
          alt={'Asset'}
          imgStyle={{
            opacity: !transcodingError ? '1' : '.36',
            pointerEvents: !transcodingError ? 'all' : 'none',
            maxHeight: '4.5vw',
            maxWidth: '100%',
            objectFit: 'cover',
          }}
        />
        {transcodingError && (
          <div
            className={`${
              transcodingError === 'PROGRESS' ? 'information-tag' : 'transcode-fail-tag'
            }  `}
          >
            <img
              src={transcodingError === 'PROGRESS' ? InformationTagIcon : TanscodingFailureIcon}
              alt="TanscodingFailureIcon"
            />
          </div>
        )}
        {playIconForVideo && (
          <div style={{ zIndex: '10' }} className="play-icon">
            <img src={PlayIcon} alt="" />
          </div>
        )}
      </div>
      <div
        className="d-flex justify-content- align-items-center"
        style={{
          background: 'none',
          width: `calc(100% - ${cardImgWidth})`,
        }}
      >
        <div
          style={{ fontSize: '12px' }}
          className="d-flex justify-content- align-items-center w-100"
        >
          {textData.map((info, idx) => (
            <p
              style={{
                marginBlockEnd: '0',
                background: 'none',
                textOverflow: 'ellipsis',
                paddingLeft: '1.5px',
                ...info.styles,
              }}
              key={idx}
            >
              {info?.name}
            </p>
          ))}

          {!isEmpty(categories) && (
            <div style={{ width: `${categoriesWidth}` }}>
              <p
                style={{
                  marginBlockEnd: '0',
                  width: '85%',
                  background: 'none',
                  //   marginRight: '-2%',
                  whiteSpace: 'nowrap',
                  flexShrink: '0',
                }}
                ref={containerElementRef}
              >
                {contentCategories.map((category, idx) => (
                  <span
                    style={!isEmpty(categories) ? categoryStyles : { marginLeft: '2vw' }}
                    ref={(el) => (elementRef.current[idx] = el)}
                    key={idx}
                  >
                    {category}
                  </span>
                ))}
                {extraCategories.length > 0 && <span>+{extraCategories.length}</span>}
              </p>
            </div>
          )}
          {transcodeEnable && (
            <div style={{ width: `${categoriesWidth}` }} className="d-flex">
              {!isEmpty(transscodeData) ? (
                transscodeData.map((info, index) => {
                  return (
                    <div key={index} className="pl-2">
                      <img
                        src={ResolutionsIcon[info.pixels]}
                        style={{
                          height: '0.87vw',
                          width: 'fit-content',
                          opacity: info.transcodeValue < 0 ? '0.4' : '1',
                        }}
                        className={``}
                      />
                      {info.transcodeValue < 100 && info.transcodeValue >= 0 ? (
                        <CProgress height={4} className="mt-1">
                          <CProgressBar color="success" value={info.transcodeValue} />
                        </CProgress>
                      ) : null}
                    </div>
                  )
                })
              ) : (
                <div className="ml-2">N/A</div>
              )}
            </div>
          )}
          {!isEmpty(actionButtonOptions) && (
            <div
              style={{
                width: actionButtonWidth,
                fontSize: '20px',
                fontWeight: '700',
                cursor: 'pointer',
              }}
              className="d-flex justify-content-center align-items-center position-relative preview-menu-dots"
            >
              <Dropdown align="center" className="">
                <Dropdown.Toggle variant="ghost" className="" id="revenue-dropdown">
                  <img src={OptionsBtn} alt="OptionsBtn" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="p-0 w-fit">
                  {actionButtonOptions.map((info, idx) => (
                    <Dropdown.Item
                      key={idx}
                      style={{ cursor: 'pointer', fontSize: '12px' }}
                      onClick={() => {
                        info?.btnFunction()
                      }}
                      className="d-flex "
                    >
                      {info?.logo ? info?.logo : null}
                      {info?.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CustomTileCard
